import styled from '@emotion/styled';
import React from 'react';

import { theme } from '../../theme/theme';

export function Battery({ isAlarm = false, percentage }) {
  return (
    <Battery.Root>
      <Battery.Status isAlarm={isAlarm} percentage={percentage} />
    </Battery.Root>
  );
}

Battery.Root = styled.div`
  border: 1px solid ${theme.color.mono_300};
  width: 24px;
  height: 12px;
  border-radius: 4px;
  position: relative;
  display: inline-flex;

  &::after {
    content: '';
    position: absolute;
    height: 4px;
    width: 2px;
    background: ${theme.color.mono_300};
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    left: 100%;
    top: 50%;
    transform: translate(2px, -50%);
  }
`;

Battery.Status = styled.div`
  margin: 1px;
  border-radius: 2px;
  width: ${(props) =>
    props.percentage == null ? '100%' : `${Math.max(Math.min(props.percentage, 100), 7)}%`};
  background: ${(props) =>
    props.percentage == null
      ? `repeating-linear-gradient(45deg, ${theme.color.mono_200}, ${theme.color.mono_200} 5px, ${theme.color.mono_100} 5px, ${theme.color.mono_100} 10px)`
      : getBatteryLevelColor(props)};
`;

function getBatteryLevelColor(props) {
  if (props.isAlarm === true) {
    if (props.percentage == null) {
      return theme.color.mono_300;
    }

    if (props.percentage < 100) {
      return theme.color.error;
    }

    return theme.color.success;
  }

  if (props.percentage == null) {
    return theme.color.mono_300;
  }

  if (props.percentage <= 5) {
    return theme.color.error;
  }

  if (props.percentage <= 20) {
    return theme.color.orange;
  }

  if (props.percentage <= 40) {
    return theme.color.yellow;
  }

  return theme.color.success;
}
